import { PRODUCT_TAB_TYPE } from '@moonpig/web-core-brand/config'
import { useStoreId } from '@moonpig/web-core-stores'
import { match } from '@moonpig/web-shared-utils'
import {
  useProductsLocaleText,
  ProductInfoProduct,
  isCardProduct,
  Module,
  E_CARD_SIZE_ID,
} from '@moonpig/web-shared-products'
import { useFlag } from '@moonpig/web-explore-flags'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { createCardMultiBuyConfiguration } from './multibuy/CardMultiBuy'
import { createCardOutOfStockConfiguration } from './out-of-stock/CardOutOfStock'
import { createCardFrictionlessFlowConfiguration } from './frictionless-flow/CardFrictionlessFlowConfiguration'
import { createCardFrictionlessFlowNoECardConfiguration } from './frictionless-flow/CardFrictionlessFlowNoECardConfiguration'

export const useModuleConfiguration = () => {
  const storeId = useStoreId()
  const localise = useProductsLocaleText()

  const isMemberPriceEnabled = useFlag('loyalty-enable-member-pricing')
  const isFrictionlessFlowEnabled = useExperiment('frictionless-flow-v1', {
    fallback: false,
  })

  return ({ product }: { product: ProductInfoProduct }): Module[] => {
    const conditions = {
      isCard: isCardProduct(product.category.department),
      inStock: product.variants.some(({ inStock }) => inStock),
      type: PRODUCT_TAB_TYPE,
      storeId,
      isMemberPriceEnabled,
      isFrictionlessFlowEnabled,
      hasECard: !!product.variants.find(({ key }) => key === E_CARD_SIZE_ID),
    }

    return match(conditions)
      .with(
        { isCard: false }, // prettier-ignore
        () => [], // prettier-ignore
      )
      .with(
        { inStock: false }, // prettier-ignore
        () => createCardOutOfStockConfiguration(), // prettier-ignore
      )
      .with(
        { isFrictionlessFlowEnabled: true, hasECard: true }, // prettier-ignore
        () => createCardFrictionlessFlowConfiguration(), // prettier-ignore
      )
      .with(
        { isFrictionlessFlowEnabled: true }, // prettier-ignore
        () => createCardFrictionlessFlowNoECardConfiguration(), // prettier-ignore
      )
      .otherwise(
        () => createCardMultiBuyConfiguration({ localise, storeId }), // prettier-ignore
      )
  }
}
